export const init = () => {

  // TRACKER 'MENU / CUSTOMER'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.menu);

  // MyDashboard
  const myDashboard = new AnalyticsClickEvent('menu-myDashboard', tracker.defaultEvent());
  myDashboard.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/dashboard\'])';
  myDashboard.options.action = 'MyDashboard';
  tracker.addEvent(myDashboard);

  // myProfile
  const myProfile = new AnalyticsClickEvent('menu-myProfile', tracker.defaultEvent());
  myProfile.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/customer-details\'])';
  myProfile.options.action = 'MyProfile';
  tracker.addEvent(myProfile);

  // myPurchase
  const myPurchases = new AnalyticsClickEvent('menu-myPurchase', tracker.defaultEvent());
  myPurchases.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/myPurchase\'])';
  myPurchases.options.action = 'MyPurchases';
  tracker.addEvent(myPurchases);

  // myRefunds
  const myRefunds = new AnalyticsClickEvent('menu-myRefunds', tracker.defaultEvent());
  myRefunds.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/myRefunds\'])';
  myRefunds.options.action = 'myRefunds';
  tracker.addEvent(myRefunds);

  // myReturns
  const myReturns = new AnalyticsClickEvent('menu-myReturns', tracker.defaultEvent());
  myReturns.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/myPurchase/listReturns\'])';
  myReturns.options.action = 'MyReturns';
  tracker.addEvent(myReturns);

  // myPreferences
  const myPreferences = new AnalyticsClickEvent('menu-myPreferences', tracker.defaultEvent());
  myPreferences.domElement = '#dashboard-account-nav #panel-preferences .panel-heading';
  myPreferences.options.action = 'MyPreferences';
  tracker.addEvent(myPreferences);

  // ... subMenu - myPreferences ...

  // myAddressBook
  const myAddressBook = new AnalyticsClickEvent('menu-myAddressBook', tracker.defaultEvent());
  myAddressBook.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/addressBook\'])';
  myAddressBook.options.action = 'MyAddressBook';
  tracker.addEvent(myAddressBook);

  // myStore
  const myStore = new AnalyticsClickEvent('menu-myStore', tracker.defaultEvent());
  myStore.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/mystore\'])';
  myStore.options.action = 'MyStore';
  tracker.addEvent(myStore);

  // mySubscription
  const mySubscription = new AnalyticsClickEvent('menu-mySubscription', tracker.defaultEvent());
  mySubscription.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/mysubscriptions\'])';
  mySubscription.options.action = 'MySubscription';
  tracker.addEvent(mySubscription);

  // myLanguage
  const myLanguage = new AnalyticsClickEvent('menu-myLanguage', tracker.defaultEvent());
  myLanguage.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/myLanguage\'])';
  myLanguage.options.action = 'MyLanguage';
  tracker.addEvent(myLanguage);

  // myMeansOfPayment
  const myMeansOfPayment = new AnalyticsClickEvent('menu-myMeansOfPayment', tracker.defaultEvent());
  myMeansOfPayment.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/myMeansOfPayment\'])';
  myMeansOfPayment.options.action = 'MyMeansOfPayment';
  tracker.addEvent(myMeansOfPayment);

  // muSports
  const mySports = new AnalyticsClickEvent('menu-mySports', tracker.defaultEvent());
  mySports.domElement = '#dashboard-account-nav #preferences li:has(a[href*=\'mySports\'])';
  mySports.options.action = 'MySports';
  tracker.addEvent(mySports);

  // myLVPHistory
  const myLVPHistory = new AnalyticsClickEvent('menu-myLVPHistory', tracker.defaultEvent());
  myLVPHistory.domElement = '#dashboard-account-nav #preferences li:has(a[href$=\'account/myHistoryLVP\'])';
  myLVPHistory.options.action = 'MyLVPHistory';
  tracker.addEvent(myLVPHistory);

  // ... end subMenu ...

  // myLoyalty
  const myLoyalty = new AnalyticsClickEvent('menu-myLoyalty', tracker.defaultEvent());
  myLoyalty.domElement = '#dashboard-account-nav .account-navigation div.panel:has(a[href$=\'account/loyalty\'])';
  myLoyalty.options.action = 'MyLoyalty';
  tracker.addEvent(myLoyalty);

  // logout
  const logout = new AnalyticsClickEvent('menu-logout', tracker.defaultEvent());
  logout.domElement = 'a#logout-button';
  logout.options.action = 'Logout';
  logout.options.label = '';
  tracker.addEvent(logout);

  // confirmLogout
  const confirmLogout = new AnalyticsClickEvent('menu-confirmLogout', tracker.defaultEvent());
  confirmLogout.domElement = '#logout-confirmation a';
  confirmLogout.options.action = 'ConfirmLogout';
  confirmLogout.options.label = '';
  tracker.addEvent(confirmLogout);


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};





// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/menu-tracker.js